import { render, staticRenderFns } from "./AppSettingsScholasticYear.vue?vue&type=template&id=007d5857&scoped=true&"
import script from "./AppSettingsScholasticYear.vue?vue&type=script&lang=js&"
export * from "./AppSettingsScholasticYear.vue?vue&type=script&lang=js&"
import style0 from "./AppSettingsScholasticYear.vue?vue&type=style&index=0&id=007d5857&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007d5857",
  null
  
)

export default component.exports